// Vendor
import * as React from 'react';

// Vendor Components
import {withStyles} from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import {translate, TranslationFunction} from 'react-i18next';
import {compose} from 'recompose';

// Shared Components
import {blue} from 'isee/config/colors';
import ButtonLink from 'isee/ui/components/button-link';

// Vendor Types
import {StyleRulesCallback, WithStyles} from 'material-ui/styles/withStyles';

// Types
interface Props {}

interface TranslatedProps {
  t: TranslationFunction;
}

type EnhancedProps = Props & TranslatedProps & WithStyles;

// Utils
import {navbarHeight} from 'isee/config/dimensions';

const styles: StyleRulesCallback = theme => ({
  headline: {
    color: theme.palette.primary.main,
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 1,
    marginBottom: theme.spacing.unit * 2,
    textTransform: 'uppercase'
  },
  root: {
    alignItems: 'center',
    backgroundColor: blue[50],
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${navbarHeight.px})`,
    justifyContent: 'center',
    padding: `0 ${theme.spacing.unit * 2}px`,
    textAlign: 'center'
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: 45,
    marginBottom: theme.spacing.unit * 3,
    maxWidth: 500
  }
});

const enhance = compose<EnhancedProps, Props>(translate(), withStyles(styles));

export const NotFound: React.SFC<EnhancedProps> = ({classes, t}) => {
  return (
    <div className={classes.root}>
      <Typography
        variant="headline"
        component="strong"
        className={classes.headline}
      >
        {t('not_found_route.headline')}
      </Typography>

      <Typography variant="display3" className={classes.title}>
        {t('not_found_route.title')}
      </Typography>

      <ButtonLink to="/" variant="raised" color="secondary">
        {t('not_found_route.button')}
      </ButtonLink>
    </div>
  );
};

export default enhance(NotFound);



// WEBPACK FOOTER //
// ./src/ui/not-found/not-found.tsx